import React from 'react';
import { 
  Chart as ChartJS, 
  CategoryScale, 
  LinearScale, 
  BarElement, 
  PointElement, 
  LineElement, 
  LineController,
  BarController,
  Legend, 
  Tooltip 
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { FaInfoCircle } from 'react-icons/fa';
import PropTypes from 'prop-types';

ChartJS.register(
  CategoryScale, 
  LinearScale, 
  BarElement, 
  PointElement, 
  LineElement, 
  LineController,
  BarController,
  Legend, 
  Tooltip
);

const ComboBarLineChart = ({ title, subtitle, labels, barData, lineData, barLabel, lineLabels, barColor, lineColors, infoTooltip = '' }) => {  const data = {
    labels,
    datasets: [
      ...lineData.map((line, idx) => ({
        type: 'line',
        label: lineLabels[idx],
        data: line,
        borderColor: lineColors[idx],
        backgroundColor: lineColors[idx],
        borderWidth: 2,
        fill: false,
        tension: 0.1,
        yAxisID: 'y',
        pointRadius: 0, // Hide the dots on the lines
        pointHoverRadius: 4, // Optional: show a dot on hover
      })),
      {
        type: 'bar',
        label: barLabel,
        data: barData,
        backgroundColor: barColor,
        barPercentage: 0.85, // Wider bars
        categoryPercentage: 0.7, // Wider bars
        yAxisID: 'y',
      }
    ]
  };
  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        display: false
      },      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 16,
          boxHeight: 8,
          font: { size: 12, weight: 400 },
          color: '#888',
          padding: 16,
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: '#888',
          font: { size: 12 },
          maxRotation: 0, // Prevent slanting
          minRotation: 0, // Prevent slanting
          autoSkip: false, // Force all labels to show
        },
      },      y: {
        beginAtZero: false,
        min: 1, // Start Y-axis at 1 instead of 0
        max: 5, // Set max value to 5
        grid: { color: '#eee' },
        ticks: {
          color: '#888',
          font: { size: 12 },
          stepSize: 1,
          callback: function(value) {
            if (Number.isInteger(value)) return value;
            return null;
          }
        },
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="combo-bar-line-card chart-card-container">      <div className="chart-card__title-row">
        <div className="chart-card__title">{title}</div>
        <span className="chart-card__icon" title={infoTooltip}>
          <FaInfoCircle size={16} color="#A0A0A0" />
        </span>
      </div>
      <div className="chart-card__value" style={{marginTop: 0}}></div>
      <div className="chart-card__subtitle">{subtitle}</div>
      <hr className="chart-card__divider" />
      <div className="chart-bar-area chart-bar-area--scrollable">
        <Chart type='bar' data={data} options={options} />
      </div>
    </div>
  );
};

ComboBarLineChart.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  labels: PropTypes.array.isRequired,
  barData: PropTypes.array.isRequired,
  lineData: PropTypes.array.isRequired,
  barLabel: PropTypes.string,
  lineLabels: PropTypes.array,
  barColor: PropTypes.string,
  lineColors: PropTypes.array,
  infoTooltip: PropTypes.string,
};

export default ComboBarLineChart;
